module.exports = __webpack_public_path__ + "static/img/aqzs01.e0b36484.jpg";